import ProfileNavigationHead from 'components/profileNavigation/Head';
import MenteeFormDisplay from 'components/UserForms/MenteeForm/MenteeFormDisplay';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import MenteeForm from 'types/MenteeForm';

const Form: FC = () => {
  const { id } = useParams();
  const { data: menteeForm } = useSWR<MenteeForm>(
    `/mentorship/mentor/mentee-form/${id}`,
  );
  return (
    <>
      <ProfileNavigationHead
        title="Questionnaire de mentorat"
        subtitle="Liste les réponses de votre mentoré au questionnaire de mentorat"
      />
      <MenteeFormDisplay variant="mentor" menteeForm={menteeForm} />
    </>
  );
};

export default Form;
